export const API_URL = process.env.NEXT_PUBLIC_API_URL;
export const SITE_URL = process.env.NEXT_PUBLIC_URL;
export const ASSETS_ADDRESS = process.env.NEXT_PUBLIC_ASSETS_URL;
